import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/ui/button/Button.vue'
import { Portal } from '@linusborg/vue-simple-portal'
import { NotifiedUserViewModel } from './viewmodels/NotifiedUser.viewmodel'
import { NotifiedUserRepositoryApiAdapter } from '../../../../../@core/fire-risk-settings/infra/notified-user-repository-adapter/NotifiedUserRepositoryApi.adapter'
import SidePanel from '@/components/ui/sidePanel/SidePanel.vue'
import NotifiedUserForm from './components/NotifiedUserForm.vue'
import { onBeforeMount, provide, watch } from 'vue'
import BaseTable from '../../../../ui/components/baseTable/BaseTable.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import Input from '@/components/ui/input/Input.vue'
import EmptyTable from '@/components/ui/emty-table/EmptyTable.vue'
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import ConfirmationModal from '@/components/ui/confirmation-modal/ConfirmationModal.vue'
import { fireRiskApi } from '@/services/clients/AxiosClients'
import TelegramModal from './components/TelegramModal.vue'
import { MonitoredAreaRepositoryApiAdapter } from '@/@core/monitored-area/infra/monitored-area-repository-adapter/MonitoredAreaRepositoryApi.adapter'

export default /*#__PURE__*/_defineComponent({
  __name: 'NotifiedUser.page',
  setup(__props) {

const repository = new NotifiedUserRepositoryApiAdapter(fireRiskApi)

const monitoredAreaRepository = new MonitoredAreaRepositoryApiAdapter(fireRiskApi)

const vm = new NotifiedUserViewModel(repository, monitoredAreaRepository)

provide('notified-user-view-model', vm)

watch(vm.openForm, (value) => {
	if (!value) vm.resetNotifiedUserState()
})

onBeforeMount(() => vm.getNotifiedUsers())

return { __sfc: true,repository, monitoredAreaRepository, vm, Button, Portal, SidePanel, NotifiedUserForm, BaseTable, Pagination, Input, EmptyTable, ContextMenu, ConfirmationModal, TelegramModal }
}

})